import { RouteHistoryEntry } from '../support/slices/uiSlice';
import { RegistryTile } from './dashboard';
import { Column } from './table';

export interface DashboardRegistryItem {
  id: string;
  name: string;
  isRssVisible?: boolean | false;
  tiles: RegistryTile[];
}

export interface Registry {
  registryValue: { [key: string]: DashboardRegistryItem | { [key: string]: DashboardRegistryItem } };
  views: {
    opportunity?: UserView[];
    customer?: UserView[];
    customer_tree?: UserView[];
  };
  history: RouteHistoryEntry[];
  notifications?: {
    releaseNotesReadDate?: string;
  }
}

interface Report {
  email: string;
  id: number;
}

export interface User {
  id: number;
  email: string;
  username: string;
  registry?: Registry;
  role?: string | 'user';
  name?: string;
  is_manager?: boolean;
  manager?: number | null;
  reports?: Report[];
}

export interface UserView {
  id: number;
  name: string;
  type: UserViewType;
  columns: Column[];
  filters?: Filter[];
  orderBy?: {column: string, order: 'asc' | 'desc'};
  userOwnedOnly?: boolean;
  tableConfig?: object;
}

export enum UserViewType {
  Opportunity = 'opportunity',
  Customer = 'customer',
  CustomerTree = 'customer_tree'
}

export type TemporaryUserView = Omit<UserView, 'id'> & { id: string };

export interface Filter {
  prop: string;
  operator: string;// these will be changing. this allows for new and old types. temporary. // 'equals' | 'is not' | 'contains' | 'doesn\'t contain' | 'is empty' | 'is not empty';
  comparison: any; // This can be more specific if you know the data types involved
}

export interface UserProductExpertise {
  id: number;
  user: { id: number; email: string };
  product: { id: number; name: string };
  expertise: { id: number; level: number };
  updated_by: string;
  last_updated: string;
}

export interface UserProductExpertiseWrite {
  user_id: number;
  product_id: number;
  expertise_level_id: number; // 1=100, 2=200, 3=300
  updated_by: string;
}